import { createAsyncThunk } from "@reduxjs/toolkit";
import { http } from "../../../utils/config";

export const getListVoucherDetail = createAsyncThunk(
    "customer/redeemvoucher/getListVoucherDetail",
    async (id) => {
      try {
        const response = await http.get(`/mcoupon/api/v1/customer/getId/${id}`);
        return response.data;
      } catch (error) {
        throw new Error("Có lỗi xảy ra trong quá trình kết nối");
      }
    }
  );